import React, { Fragment, useContext, useEffect } from "react";
import SaitButton from "../atomic/SaitButton";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SaitSteppers from "../atomic/SaitStepper";
import { useDispatch } from "react-redux";
import { setGlobalError } from "../store/globalMessageReducer";
import SaitDialog from "../atomic/SaitDialog";
import i18next from "../localization/i18n";
import { Box } from "@mui/material";
import { checkOpen } from "../utils/SaitUtils";
import { ModuleContext } from "../utils/Constants";

export default function Wizard(props) {
	const dispatch = useDispatch();
	const module = useContext(ModuleContext);

	const [activePage, setActivePage] = React.useState(0);

	const handlepPeviousPage = () => {
		if (activePage > 0) {
			props.pages[activePage].prevStepFn?.();
			setActivePage(activePage - 1);
		}
	};

	useEffect(() => {
		if (!checkOpen(props.open)) {
			setActivePage(0);
		}
	}, [props.open]);

	const handleNextPage = async () => {
		let mandatoryFields = props.pages[activePage].mandatoryFields;
		let allFieldsComplete = true;
		if (mandatoryFields) {
			mandatoryFields.forEach((mandatoryField, index) => {
				if (allFieldsComplete) {
					if (Array.isArray(mandatoryField)) {
						// ARRAY
						if (mandatoryField.length === 0) {
							allFieldsComplete = false;
						}
					} else {
						if (typeof mandatoryField !== "undefined" && mandatoryField !== null) {
							// NON E' UNDEFINED O NULL
							if (typeof mandatoryField === "string") {
								// STRING
								if (!mandatoryField) {
									allFieldsComplete = false;
								}
							} else if (typeof mandatoryField === "object") {
								// OBJECT
								if (Object.values(mandatoryField).every((value) => value === "" || value === null)) {
									allFieldsComplete = false;
								}
							}
						} else {
							// E' UNDEFINED
							allFieldsComplete = false;
						}
					}
				}
			});
		}

		if (allFieldsComplete) {
			if (activePage === props.pages.length - 1) {
				props.conclude?.();
			} else {
				// Funzione opzionale da poter richiamare al click sul bottone "PROSEGUI".
				// Nel caso in cui tale funzione esista, è necessario verificare che l'esecuzione della stessa
				// dia esito positivo per poter cambiare pagina.
				const resp = await props.pages[activePage].nextStepFn?.();
				if (resp === false) return;
				setActivePage(activePage + 1);
			}
		} else {
			dispatch(
				setGlobalError({
					module: module,
					errorMessage: i18next.t("error_enter_all_required_fields"),
				})
			);
		}
	};

	const handleClose = () => {
		setActivePage(0);
		props.close();
	};

	return (
		<SaitDialog
			open={props.open}
			title={props.title}
			width="lg"
			fullScreen={props.fullScreen}
			minHeight={props.minHeight}
			stepper={props.pages[0].stepper && <SaitSteppers activePage={activePage} pages={props.pages} />}
			content={props.pages[activePage].component}
			/* <Fragment>
				{props.pages.length ? (
					props.pages.map((page, index) => (
						<Box
							key={index}
							component="span"
							sx={{
								display:
									index === activePage
										? "flex"
										: "none",
								flex: 1,
							}}
						>
							{props.pages[index].component}
						</Box>
					))
				) : (
					<Fragment></Fragment>
				)}
			</Fragment> */
			actions={
				<Fragment>
					<SaitButton text={i18next.t("cancel")} color="error" endIcon={<CancelIcon />} onClick={handleClose} />
					{activePage !== 0 && <SaitButton text={i18next.t("back")} startIcon={<ArrowBackIosIcon />} onClick={handlepPeviousPage} />}
					<Box sx={{ flexGrow: 1 }} />
					{activePage === props.pages.length - 1 ? (
						!props.hideButton && <SaitButton text={i18next.t("conclude")} endIcon={<ArrowForwardIosIcon />} onClick={handleNextPage} color="success" />
					) : (
						<SaitButton text={i18next.t("continue")} endIcon={<ArrowForwardIosIcon />} onClick={handleNextPage} color="primary" />
					)}
				</Fragment>
			}
		/>
	);
}
